import { render, staticRenderFns } from "./TransactionLogDoctor.vue?vue&type=template&id=6c83b09a&"
import script from "./TransactionLogDoctor.vue?vue&type=script&lang=js&"
export * from "./TransactionLogDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports